var _a;
export var ISOCountryEnum;
(function (ISOCountryEnum) {
    ISOCountryEnum["ECUADOR"] = "Ecuador";
    ISOCountryEnum["COLOMBIA"] = "Colombia";
    ISOCountryEnum["PERU"] = "Peru";
    ISOCountryEnum["CHILE"] = "Chile";
    ISOCountryEnum["MEXICO"] = "Mexico";
    ISOCountryEnum["BRASIL"] = "Brasil";
    ISOCountryEnum["ELSALVADOR"] = "ElSalvador";
    ISOCountryEnum["PANAMA"] = "Panama";
    ISOCountryEnum["COSTARICA"] = "CostaRica";
    ISOCountryEnum["NICARAGUA"] = "Nicaragua";
    ISOCountryEnum["HONDURAS"] = "Honduras";
    ISOCountryEnum["GUATEMALA"] = "Guatemala";
})(ISOCountryEnum || (ISOCountryEnum = {}));
export var COUNTRY_ISO_CODE = (_a = {},
    _a[ISOCountryEnum.ECUADOR] = "EC",
    _a[ISOCountryEnum.COLOMBIA] = "CO",
    _a[ISOCountryEnum.PERU] = "PE",
    _a[ISOCountryEnum.CHILE] = "CL",
    _a[ISOCountryEnum.MEXICO] = "MX",
    _a[ISOCountryEnum.BRASIL] = "BR",
    _a[ISOCountryEnum.ELSALVADOR] = "SV",
    _a[ISOCountryEnum.PANAMA] = "PA",
    _a[ISOCountryEnum.COSTARICA] = "CR",
    _a[ISOCountryEnum.NICARAGUA] = "NI",
    _a[ISOCountryEnum.HONDURAS] = "HN",
    _a[ISOCountryEnum.GUATEMALA] = "GT",
    _a);
